'use strict';

(function() {
	angular.module('onboarding.common.settings')
		.directive('cobBrokerProfile', cobBrokerProfile);

	cobBrokerProfile.$inject = [
		'brokerSettingsService', 'authenticationService', 'subjectObserverMessagesService', 'observerService',
		'sessionService'
	];

	var brokerSettingsService,
		authenticationService,
		subjectObserverMessagesService,
		observerService,
		subjectMessages,
		observerMessages,
		sessionService;

	function cobBrokerProfile(_brokerSettingsService_,
		_authenticationService_,
		_subjectObserverMessagesService_,
		_observerService_,
		_sessionService_) {

		brokerSettingsService = _brokerSettingsService_;
		authenticationService = _authenticationService_;
		observerService = _observerService_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		sessionService = _sessionService_;

		return {
			restrict: 'E',
			scope: {
				settings: '=',
				errors: '='
			},
			templateUrl: '/app/common/settings/broker/cobBrokerProfile.html',
			replace: true,
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			//registerEventHandlers();
			scope.isInternalAdmin = isInternalAdmin;
			scope.discardChanges = discardChanges;
			scope.newPasswordValidation = newPasswordValidation;
			scope.confirmPasswordValidation = confirmPasswordValidation;
			scope.passwordIsValid = passwordIsValid;
			scope.saveChanges = saveChanges;
			scope.validatePasswordsSame = validatePasswordsSame;

			discardChanges();
		}

		function isInternalAdmin() {
			return sessionService.isAuthorizedInternalAdmin();
		}

		function discardChanges() {
			scope.updatePassword = { newPassword: '', confirmNewPassword: '' };
			scope.showPasswordsDoNotMatch = false;
			scope.showPasswordIsNotValid = false;
			scope.showPasswordIsEmpty = false;
			scope.showPasswordChanged = false;
			scope.isDirty = false;

			observerService.sendMessageToSubject(
				scope,
				subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_PROFILE_SETTINGS_CLEAN);
		}

		function saveChanges() {

			if (passwordIsValid()) {
				authenticationService.changePassword(scope.updatePassword.confirmNewPassword)
					.then(function(response) {
						if (response.data.isSuccess) {
							scope.showPasswordChanged = true;
							scope.showPasswordsDoNotMatch = false;
							scope.showPasswordIsNotValid = false;
							discardChanges();
							observerService.sendMessageToSubject(
								scope,
								subjectObserverMessagesService.getSubjectMessages()
									.COB_SUBJECT_PROFILE_SETTINGS_SAVE_VIEW);
						}
					})
					.catch(function() {
						// handle csb exception
					});
			}

		}

		function passwordIsValid() {
			var confirmPass = confirmPasswordValidation();
			var newPass = newPasswordValidation();
			if (confirmPass && newPass) {
				return true;
			}

			return false;
		}

		function confirmPasswordValidation() {

			observerService.sendMessageToSubject(
				scope,
				subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_PROFILE_SETTINGS_DIRTY);

			if (scope.updatePassword.confirmNewPassword !== scope.updatePassword.newPassword) {
				scope.showPasswordsDoNotMatch = true;

				return false;
			}

			scope.showPasswordsDoNotMatch = false;

			return true;
		}

		function validatePasswordsSame() {
			if (scope.updatePassword.confirmNewPassword !== scope.updatePassword.newPassword) {
				scope.showPasswordsDoNotMatch = true;
			}
		}

		function newPasswordValidation() {
			// eslint-disable-next-line no-useless-escape
			var re = /^([a-zA-Z0-9\p{P}$\^\+=~`|]{6,16})$/;

			observerService.sendMessageToSubject(
				scope,
				subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_PROFILE_SETTINGS_DIRTY);

			// outer validation is for default behavior
			if (scope.updatePassword.newPassword.length > 0) {

				if (!re.test(scope.updatePassword.newPassword) ||
                    scope.updatePassword.newPassword.length < 4 ||
                    scope.updatePassword.newPassword.length > 16) {

					scope.showPasswordIsEmpty = false;
					scope.showPasswordIsNotValid = true;

					return false;
				}
			} else {
				scope.showPasswordIsEmpty = true;
				scope.showPasswordIsNotValid = false;

				return false;
			}

			scope.showPasswordIsEmpty = false;
			scope.showPasswordIsNotValid = false;

			return true;
		}
	}
})();
